// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-shell {
  min-height: calc(100vh - 77px);
  padding: 1.5rem 26px 2.5rem;
  background-color: #f5f1e9;
}

.user-shell__inner {
  max-width: 920px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

@media (min-width: 720px) {
  .user-shell__inner {
    flex-direction: row;
    align-items: flex-start;
    gap: 2rem;
  }
}

.user-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.75rem;
  background: #fff;
  border-radius: 14px;
  border: 1px solid #e8e4df;
  box-shadow: 0 2px 12px rgba(78, 63, 58, 0.06);
}

@media (min-width: 720px) {
  .user-nav {
    flex-direction: column;
    min-width: 200px;
    flex-shrink: 0;
  }
}

.user-nav__link {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #6b5d58;
  text-decoration: none;
  padding: 0.5rem 0.75rem;
  border-radius: 10px;
  transition: background 0.15s ease, color 0.15s ease;
}

.user-nav__link:hover {
  color: #4e3f3a;
  background: #faf9f7;
}

.user-nav__link--active {
  color: #fff;
  background: #fc761f;
}

.user-nav__link--active:hover {
  color: #fff;
  background: #e56a18;
}

.user-panel {
  flex: 1;
  min-width: 0;
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e8e4df;
  box-shadow: 0 2px 16px rgba(78, 63, 58, 0.08);
  padding: 1.75rem 1.5rem;
}

.user-panel__title {
  margin: 0 0 1.25rem 0;
  font-family: 'Neucha', cursive;
  font-size: 1.5rem;
  font-weight: 400;
  color: #4e3f3a;
}

.user-dl {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 0.65rem 1rem;
  font-family: 'Roboto', sans-serif;
  font-size: 0.9375rem;
}

.user-dl dt {
  margin: 0;
  color: #6b5d58;
  font-weight: 600;
}

.user-dl dd {
  margin: 0;
  color: #4e3f3a;
}

.user-muted {
  font-size: 0.875rem;
  color: #6b5d58;
  margin: 0 0 1rem 0;
}

.user-address-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.user-address-card {
  border: 1px solid #e8e4df;
  border-radius: 12px;
  padding: 1rem 1.1rem;
  background: #faf9f7;
}

.user-address-card__row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}

.user-address-card__text {
  margin: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 0.9375rem;
  color: #4e3f3a;
  flex: 1;
  min-width: 0;
}

.user-badge {
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 600;
  color: #fc761f;
  margin-top: 0.35rem;
}

.user-address-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;
}

.user-btn {
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  padding: 0.45rem 0.85rem;
  border-radius: 8px;
  border: 1px solid #e8e4df;
  background: #fff;
  color: #4e3f3a;
  cursor: pointer;
}

.user-btn:hover {
  border-color: #fc761f;
  color: #fc761f;
}

.user-btn--primary {
  background: #fc761f;
  border-color: #fc761f;
  color: #fff;
}

.user-btn--primary:hover {
  background: #e56a18;
  border-color: #e56a18;
  color: #fff;
}

.user-btn--danger {
  border-color: #fecaca;
  color: #991b1b;
  background: #fef2f2;
}

.user-btn--danger:hover {
  border-color: #f87171;
  color: #7f1d1d;
}

.user-form {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.user-form label {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #4e3f3a;
}

.user-form input[type='text'],
.user-form input[type='email'],
.user-form input[type='tel'] {
  font-size: 0.9375rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid #e8e4df;
  border-radius: 8px;
  background: #fff;
}

.user-form-input--invalid {
  border-color: #f87171 !important;
}

.user-form-msg {
  font-size: 0.8125rem;
  margin-top: -0.25rem;
}

.user-form-msg--error {
  color: #991b1b;
}

.user-form-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.user-orders-table-wrap {
  overflow-x: auto;
}

.user-orders-table {
  width: 100%;
  border-collapse: collapse;
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;
}

.user-orders-table th,
.user-orders-table td {
  text-align: left;
  padding: 0.6rem 0.5rem;
  border-bottom: 1px solid #e8e4df;
  vertical-align: top;
}

.user-orders-table th {
  color: #6b5d58;
  font-weight: 600;
  white-space: nowrap;
}

.user-orders-table td {
  color: #4e3f3a;
}

.user-orders-table--interactive .user-order-row {
  cursor: pointer;
  transition: background 0.12s ease;
}

.user-orders-table--interactive .user-order-row:hover {
  background: #fff7ed;
}

.user-orders-table--interactive .user-order-row--active {
  background: #ffedd5;
  box-shadow: inset 3px 0 0 #fc761f;
}

.user-order-empty {
  font-size: 0.9375rem;
  color: #6b5d58;
  margin: 0;
}

.user-order-pay-btn {
  font: inherit;
  font-size: 0.8125rem;
  font-weight: 600;
  padding: 0.35rem 0.65rem;
  border-radius: 6px;
  border: 1px solid #fc761f;
  background: #fff7ed;
  color: #c2410c;
  cursor: pointer;
}

.user-order-pay-btn:hover {
  background: #ffedd5;
}

.user-footer-link {
  display: inline-block;
  margin-top: 1.25rem;
  font-size: 0.875rem;
  color: #fc761f;
  text-decoration: none;
  font-weight: 500;
}

.user-footer-link:hover {
  text-decoration: underline;
}

.user-profile__bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem 1rem;
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid #e8e4df;
}

.user-profile__bar .user-footer-link {
  margin-top: 0;
}

@media (max-width: 768px) {
  .user-shell {
    padding: 1rem 16px 1.5rem;
  }

  .user-panel {
    padding: 1rem 0.9rem;
    border-radius: 12px;
  }

  .user-dl {
    grid-template-columns: 1fr;
    gap: 0.25rem;
  }

  .user-dl dt {
    margin-top: 0.4rem;
  }

  .user-dl dd {
    margin-bottom: 0.2rem;
  }
}

@media (max-width: 430px) {
  .user-shell {
    padding: 0.75rem 12px 1.25rem;
  }

  .user-panel__title {
    font-size: 1.3rem;
    margin-bottom: 0.9rem;
  }

  .user-nav {
    padding: 0.5rem;
    gap: 0.35rem;
  }

  .user-nav__link {
    font-size: 0.875rem;
    padding: 0.42rem 0.55rem;
  }

  .user-address-card {
    padding: 0.75rem;
  }

  .user-address-actions .user-btn {
    flex: 1 1 100%;
    text-align: center;
  }

  .user-orders-table {
    font-size: 0.8125rem;
  }

  .user-orders-table th,
  .user-orders-table td {
    padding: 0.45rem 0.4rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/user/User.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE;IACE,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE;IACE,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,iBAAiB;EACjB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,oBAAoB;EACpB,cAAc;EACd,OAAO;EACP,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,oBAAoB;EACpB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;IAEE,uBAAuB;EACzB;AACF","sourcesContent":[".user-shell {\n  min-height: calc(100vh - 77px);\n  padding: 1.5rem 26px 2.5rem;\n  background-color: #f5f1e9;\n}\n\n.user-shell__inner {\n  max-width: 920px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n@media (min-width: 720px) {\n  .user-shell__inner {\n    flex-direction: row;\n    align-items: flex-start;\n    gap: 2rem;\n  }\n}\n\n.user-nav {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  padding: 0.75rem;\n  background: #fff;\n  border-radius: 14px;\n  border: 1px solid #e8e4df;\n  box-shadow: 0 2px 12px rgba(78, 63, 58, 0.06);\n}\n\n@media (min-width: 720px) {\n  .user-nav {\n    flex-direction: column;\n    min-width: 200px;\n    flex-shrink: 0;\n  }\n}\n\n.user-nav__link {\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.9375rem;\n  font-weight: 500;\n  color: #6b5d58;\n  text-decoration: none;\n  padding: 0.5rem 0.75rem;\n  border-radius: 10px;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.user-nav__link:hover {\n  color: #4e3f3a;\n  background: #faf9f7;\n}\n\n.user-nav__link--active {\n  color: #fff;\n  background: #fc761f;\n}\n\n.user-nav__link--active:hover {\n  color: #fff;\n  background: #e56a18;\n}\n\n.user-panel {\n  flex: 1;\n  min-width: 0;\n  background: #fff;\n  border-radius: 16px;\n  border: 1px solid #e8e4df;\n  box-shadow: 0 2px 16px rgba(78, 63, 58, 0.08);\n  padding: 1.75rem 1.5rem;\n}\n\n.user-panel__title {\n  margin: 0 0 1.25rem 0;\n  font-family: 'Neucha', cursive;\n  font-size: 1.5rem;\n  font-weight: 400;\n  color: #4e3f3a;\n}\n\n.user-dl {\n  display: grid;\n  grid-template-columns: 140px 1fr;\n  gap: 0.65rem 1rem;\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.9375rem;\n}\n\n.user-dl dt {\n  margin: 0;\n  color: #6b5d58;\n  font-weight: 600;\n}\n\n.user-dl dd {\n  margin: 0;\n  color: #4e3f3a;\n}\n\n.user-muted {\n  font-size: 0.875rem;\n  color: #6b5d58;\n  margin: 0 0 1rem 0;\n}\n\n.user-address-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.user-address-card {\n  border: 1px solid #e8e4df;\n  border-radius: 12px;\n  padding: 1rem 1.1rem;\n  background: #faf9f7;\n}\n\n.user-address-card__row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.user-address-card__text {\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.9375rem;\n  color: #4e3f3a;\n  flex: 1;\n  min-width: 0;\n}\n\n.user-badge {\n  display: inline-block;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #fc761f;\n  margin-top: 0.35rem;\n}\n\n.user-address-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-top: 0.75rem;\n}\n\n.user-btn {\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.875rem;\n  font-weight: 600;\n  padding: 0.45rem 0.85rem;\n  border-radius: 8px;\n  border: 1px solid #e8e4df;\n  background: #fff;\n  color: #4e3f3a;\n  cursor: pointer;\n}\n\n.user-btn:hover {\n  border-color: #fc761f;\n  color: #fc761f;\n}\n\n.user-btn--primary {\n  background: #fc761f;\n  border-color: #fc761f;\n  color: #fff;\n}\n\n.user-btn--primary:hover {\n  background: #e56a18;\n  border-color: #e56a18;\n  color: #fff;\n}\n\n.user-btn--danger {\n  border-color: #fecaca;\n  color: #991b1b;\n  background: #fef2f2;\n}\n\n.user-btn--danger:hover {\n  border-color: #f87171;\n  color: #7f1d1d;\n}\n\n.user-form {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n.user-form label {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: #4e3f3a;\n}\n\n.user-form input[type='text'],\n.user-form input[type='email'],\n.user-form input[type='tel'] {\n  font-size: 0.9375rem;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #e8e4df;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.user-form-input--invalid {\n  border-color: #f87171 !important;\n}\n\n.user-form-msg {\n  font-size: 0.8125rem;\n  margin-top: -0.25rem;\n}\n\n.user-form-msg--error {\n  color: #991b1b;\n}\n\n.user-form-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.user-orders-table-wrap {\n  overflow-x: auto;\n}\n\n.user-orders-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.875rem;\n}\n\n.user-orders-table th,\n.user-orders-table td {\n  text-align: left;\n  padding: 0.6rem 0.5rem;\n  border-bottom: 1px solid #e8e4df;\n  vertical-align: top;\n}\n\n.user-orders-table th {\n  color: #6b5d58;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.user-orders-table td {\n  color: #4e3f3a;\n}\n\n.user-orders-table--interactive .user-order-row {\n  cursor: pointer;\n  transition: background 0.12s ease;\n}\n\n.user-orders-table--interactive .user-order-row:hover {\n  background: #fff7ed;\n}\n\n.user-orders-table--interactive .user-order-row--active {\n  background: #ffedd5;\n  box-shadow: inset 3px 0 0 #fc761f;\n}\n\n.user-order-empty {\n  font-size: 0.9375rem;\n  color: #6b5d58;\n  margin: 0;\n}\n\n.user-order-pay-btn {\n  font: inherit;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  padding: 0.35rem 0.65rem;\n  border-radius: 6px;\n  border: 1px solid #fc761f;\n  background: #fff7ed;\n  color: #c2410c;\n  cursor: pointer;\n}\n\n.user-order-pay-btn:hover {\n  background: #ffedd5;\n}\n\n.user-footer-link {\n  display: inline-block;\n  margin-top: 1.25rem;\n  font-size: 0.875rem;\n  color: #fc761f;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.user-footer-link:hover {\n  text-decoration: underline;\n}\n\n.user-profile__bar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem 1rem;\n  margin-top: 1.25rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e8e4df;\n}\n\n.user-profile__bar .user-footer-link {\n  margin-top: 0;\n}\n\n@media (max-width: 768px) {\n  .user-shell {\n    padding: 1rem 16px 1.5rem;\n  }\n\n  .user-panel {\n    padding: 1rem 0.9rem;\n    border-radius: 12px;\n  }\n\n  .user-dl {\n    grid-template-columns: 1fr;\n    gap: 0.25rem;\n  }\n\n  .user-dl dt {\n    margin-top: 0.4rem;\n  }\n\n  .user-dl dd {\n    margin-bottom: 0.2rem;\n  }\n}\n\n@media (max-width: 430px) {\n  .user-shell {\n    padding: 0.75rem 12px 1.25rem;\n  }\n\n  .user-panel__title {\n    font-size: 1.3rem;\n    margin-bottom: 0.9rem;\n  }\n\n  .user-nav {\n    padding: 0.5rem;\n    gap: 0.35rem;\n  }\n\n  .user-nav__link {\n    font-size: 0.875rem;\n    padding: 0.42rem 0.55rem;\n  }\n\n  .user-address-card {\n    padding: 0.75rem;\n  }\n\n  .user-address-actions .user-btn {\n    flex: 1 1 100%;\n    text-align: center;\n  }\n\n  .user-orders-table {\n    font-size: 0.8125rem;\n  }\n\n  .user-orders-table th,\n  .user-orders-table td {\n    padding: 0.45rem 0.4rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
